import React, { useState } from 'react';
import Topbar from '../../../PulseSurvey/Topbar';
import Icons from '../../../../component/svgs/icons';
import { Link, useNavigate } from 'react-router-dom';
import { surveyApi } from '../../../../api/surveyApi';
import { CompanyApi } from '../../../../api/companyApi';
import Loader from '../../../../component/common/Loader';
import { capitalizeFirstLetter, capitalizeWords, getPathForSurvey } from '../../../../utils/helper';
import CommonSelect from '../../../../component/common/select/CommonSelect';
import AddEditRewardValidation from '../../../../validation/AddEditRewardValidation';
import ChallangeSuccessModal from '../../../../component/common/modals/ChallangeSuccessModal';
import ChallangeApprovalModal from '../../../../component/common/modals/ChallangeApprovalModal';

const points = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' }
];

const AddEditRewards = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [loading, setLoading] = useState(false);
  const [adminList, setSuperAdminList] = useState([]);
  const { userType } = JSON.parse(localStorage.getItem('userData'));
  const location = new URLSearchParams(window.location.search);
  const id = location.get('id');
  const tab = location.get('tab');
  const view = location.get('view');
  const [error, setError] = useState({
    title: '',
    description: '',
    approvalBy: '',
    points: ''
  });
  const [reward, setReward] = useState({
    id: '',
    approvalBy: '',
    title: '',
    description: '',
    points: ''
  });

  const handleClose = () => {
    setOpen(false);
    navigate(getPathForSurvey('/team-challanges'));
  };

  const handleChange = (e) => {
    let processedValue = e.target.value;

    // Auto-capitalize based on field type
    if (e.target.name === 'title') {
      processedValue = capitalizeWords(e.target.value);
    } else if (e.target.name === 'description') {
      processedValue = capitalizeFirstLetter(e.target.value);
    }

    setReward({ ...reward, [e.target.name]: processedValue });
    setError({ ...error, [e.target.name]: '' });
  };

  const handleChange2 = (e) => {
    setReward({ ...reward, points: e.value });
    setError({ ...error, points: '' });
  };

  const getadminList = () => {
    surveyApi.getAdminList(0).then(async (response) => {
      if (response?.data?.meta?.code === 1) {
        setOpen2(true);
        setLoading(false);
        setSuperAdminList(response?.data?.data);
      } else {
        setLoading(false);
      }
    });
  };

  const getadminList2 = () => {
    CompanyApi.getAdminListCompany(3).then(async (response) => {
      if (response?.data?.meta?.code === 1) {
        setOpen2(true);
        setLoading(false);
        setSuperAdminList(response?.data?.data);
      } else {
        setLoading(false);
      }
    });
  };

  const handleSubmit = () => {
    const { errors, isValid } = AddEditRewardValidation(reward);
    if (isValid) {
      const payload = {
        title: reward.title,
        description: reward.description,
        points: reward.points
      };
      if (id) {
        payload.id = reward.id;
        if (userType === 0 || userType === 1) {
          if (userType === 0) {
            setOpen(true);
            console.log('++++++++++++++++ , handleSubmit , payload', payload);
          } else {
            setLoading(true);
            getadminList();
          }
        } else {
          if (userType === 3 || userType === 4) {
            if (userType === 3) {
              setOpen(true);
              console.log('++++++++++++++++ , handleSubmit , payload', payload);
            } else {
              setLoading(true);
              getadminList2();
            }
          }
        }
      } else {
        if (userType === 0 || userType === 1) {
          if (userType === 0) {
            setOpen(true);
            console.log('++++++++++++++++ , handleSubmit , payload', payload);
          } else {
            setLoading(true);
            getadminList();
          }
        } else {
          if (userType === 3 || userType === 4) {
            if (userType === 3) {
              setOpen(true);
              console.log('++++++++++++++++ , handleSubmit , payload', payload);
            } else {
              setLoading(true);
              getadminList2();
            }
          }
        }
      }
    } else {
      setError(errors);
    }
  };

  const handleSendChallengeWithApproval = () => {
    if (reward?.approvalBy) {
      const payload = {
        title: reward.title,
        description: reward.description,
        points: reward.points,
        approvalBy: reward.approvalBy
      };
      reward.id && (payload.id = reward.id);
      setOpen(true);
      setOpen2(false);
      console.log('++++++++++++++++ , handleSubmit , payload', payload);
    } else {
      setError({ ...error, approvalBy: 'Please select admin.' });
    }
  };

  return (
    <div className="mx-auto max-w-[1640px] hide-scrollbar font-work-sans">
      {loading && <Loader />}
      <div className="font-work-sans lg:ps-5">
        <Topbar title={id ? 'Edit Reward' : 'New Reward'} />
        <div className="grid-cols-12 flex justify-between items-center sm:flex-row flex-col lg:mt-10">
          <div className="sm:col-span-6 col-span-12 flex sm:flex-row flex-wrap justify-start sm:gap-8 gap-4 lg:gap-12 sm:mt-0 w-full">
            <Link
              className={`text-[20px] font-medium leading-9 
              ${
                tab === '1'
                  ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                  : 'text-shoorah-gray9'
              } ${view === '1' ? 'pointer-events-none' : ''}`}
              to={getPathForSurvey('/team-challanges/add-edit-rewards?tab=1&id=' + id)}
            >
              Details
            </Link>
            <Link
              className={`text-[20px] font-medium leading-9 
              ${
                tab === '2'
                  ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                  : 'text-shoorah-gray9'
              } pointer-events-none`}
              to={getPathForSurvey('/team-challanges/add-edit-rewards?tab=2')}
            >
              About
            </Link>
            <Link
              className={`text-[20px] font-medium leading-9 
              ${
                tab === '3'
                  ? 'text-shoorah-lightBlack dark:text-shoorah-darkBg'
                  : 'text-shoorah-gray9'
              } pointer-events-none`}
              to={getPathForSurvey('/team-challanges/add-edit-rewards?tab=3')}
            >
              Gift Card
            </Link>
          </div>
          <div className="sm:col-span-6 col-span-12 relative justify-end flex w-full items-center mt-3 sm:mt-0 text-[1rem]">
            <Link
              to={getPathForSurvey(
                `/team-challanges/add-edit-rewards?${view === '1' ? 'tab=1' : 'view=1'}&id=${id}`
              )}
              className="border border-shoorah-lightBlack text-shoorah-lightBlack dark:text-shoorah-darkBg dark:border-shoorah-darkBg rounded-[100px] px-4 sm:px-7 py-2 font-medium leading-[22px] truncate text-[14px]"
            >
              {view !== '1' ? 'Preview' : 'Edit'} Reward
            </Link>
          </div>
        </div>
        <div className="lg:mt-9 mt-5 rounded-2xl border-[1.5px] border-shoorah-borderGray bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder sm:p-6 p-4">
          <div className="sm:grid sm:grid-cols-12 text-[16px] text-shoorah-lightBlack dark:text-shoorah-darkBg gap-5 sm:w-[80%] add-survey-card">
            <div className="col-span-7">
              <label htmlFor="title" className="font-medium text-[16px] leading-9 mb-1">
                Reward Title
              </label>
              <div className="input-field">
                <input
                  className="w-full h-10 bg-shoorah-normanGray border-[1.5px] text-[14px] border-shoorah-borderGray rounded-[8px] px-4 flex flex-col justify-center items-start relative dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none"
                  type="text"
                  name="title"
                  id="title"
                  autoComplete="off"
                  onChange={handleChange}
                  placeholder="Enter title: e.g Social Anxiety Assessment"
                />
              </div>
              {error.title && <span className="text-red-500 text-sm">{error.title}</span>}
            </div>
            <div className="col-span-5">
              <label htmlFor="points" className="font-medium text-[16px] leading-9 mb-1">
                Reward Points
              </label>
              <div className="input-field">
                <CommonSelect
                  name="points"
                  options={points}
                  onChange={handleChange2}
                  value={points.find((option) => option.value === reward.points)}
                />
              </div>
              {error.points && <span className="text-red-500 text-sm">{error.points}</span>}
            </div>
          </div>
          <div className="text-[16px] text-shoorah-lightBlack mt-6 sm:w-[80%] dark:text-shoorah-darkBg">
            <label htmlFor="description" className="font-medium text-[16px] leading-9 mb-1">
              Reward Description
            </label>
            <div className="input-field">
              <textarea
                className="w-full block rounded-lg px-4 py-2 text-[14px] bg-shoorah-normanGray border-[1.5px] border-shoorah-borderGray min-h-[100px] resize-none mb-0 dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder focus:outline-none"
                name="description"
                id="description"
                autoComplete="off"
                onChange={handleChange}
                placeholder="Enter description: e.g Take this assessment to find out if you may have symptoms of social anxiety."
              ></textarea>
            </div>
            {error.description && <span className="text-red-500 text-sm">{error.description}</span>}
          </div>
        </div>

        {view !== '1' && (
          <div className="lg:mt-8 mt-5 flex justify-end">
            <button
              onClick={handleSubmit}
              className="btn-primary"
            >
              Publish Reward <Icons.chevronRightIcon />
            </button>
          </div>
        )}
      </div>
      <ChallangeSuccessModal
        open={open}
        btn="Manage Reward"
        message="You’ve successfully created a Shoorah reward"
        desc="You can now manage this reward and access valuable insights"
        setOpen={setOpen}
        handleClose={handleClose}
      />
      <ChallangeApprovalModal
        open={open2}
        btn="My Rewards"
        message="You're currently unable to share this reward"
        desc="Send the reward to an admin to gain approval"
        adminList={adminList}
        error={error.approvalBy}
        handleChange={(e) => {
          setReward({ ...reward, approvalBy: e.value });
          setError({ ...error, approvalBy: '' });
        }}
        handleSendChallengeWithApproval={() => handleSendChallengeWithApproval()}
      />
    </div>
  );
};

export default AddEditRewards;
